import AddFilterButtonComponent from './AddButton';

const AddFilterButton = AddFilterButtonComponent;

export { AddFilterButton as default };
